export const resources = {
  en: {
    translation: {
      Chats: "Chats",
      Dashboard: "Dashboard",
      Users: "Users",
      Accounts: "Accounts",
      "User & Contact": "User & Contact"
    }
  },
  mn: {
    translation: {
      Chats: "Чат",
      Dashboard: "Админ панел",
      Users: "Хэрэглэгчид",
    }
  }
};